(function () {
	angular
		.module('trackeye')
		.directive('lessThan', lessThan);

	/**
	 * Assert if input value is less than given model value
	 */
	function lessThan() {
		return {
			require: "ngModel",
			scope: {
				otherModelValue: "=lessThan"
			},
			link: function (scope, element, attributes, ngModel) {

				ngModel.$validators.lessThan = function (modelValue) {
					return parseInt(modelValue) < parseInt(scope.otherModelValue);
				};

				scope.$watch("otherModelValue", function () {
					ngModel.$validate();
				});
			}
		};
	}
})();